import { render, staticRenderFns } from "./DiyNewDashboard.vue?vue&type=template&id=6a94a1ba&scoped=true"
import script from "./DiyNewDashboard.vue?vue&type=script&lang=js"
export * from "./DiyNewDashboard.vue?vue&type=script&lang=js"
import style0 from "./DiyNewDashboard.vue?vue&type=style&index=0&id=6a94a1ba&prod&scoped=true&lang=css"
import style1 from "./public-report-v2/report-v2.css?vue&type=style&index=1&id=6a94a1ba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a94a1ba",
  null
  
)

export default component.exports